import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import Button from 'material-ui/Button';
import { colors } from 'kaizen-ui-colors/lib';
import { IStore } from '../../domain/store';
import { EmptyStateImage } from './EmptyStateImage';

interface IProps {
  store?: IStore;
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin-top: 5vh;

  p {
    font-size: 1.230769231rem;
    margin-bottom: 36px;
  }

  > svg {
    color: ${colors.ash_light__c3cbdd};
    margin-bottom: 12px;
  }
`;

@inject('store')
@observer
export class OnboardingScreen extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
    this.onClick = this.onClick.bind(this);
  }

  private onClick() {
    const { kaizenLabServiceStore, organizationStore } = this.store;
    const liftReportInfo = kaizenLabServiceStore
      .getAll(organizationStore.selectedOrganizationId)
      .filter(service => service.label === 'lift_report')[0];
    window.open(liftReportInfo.url);
  }

  public render() {
    const { kaizenLabServiceStore, organizationStore } = this.store;
    const liftReportInfo = kaizenLabServiceStore
      .getAll(organizationStore.selectedOrganizationId)
      .filter(service => service.label === 'lift_report')[0];
    return (
      <Wrapper>
        <EmptyStateImage />
        <h1>Experience Portfolio の準備を始めましょう</h1>
        <p>Lift Report の集計対象のゴールを設定すると、Experience Portfolio も同時に作成されます。</p>
        {liftReportInfo && liftReportInfo.permissions.includes('write') ? (
          <Button color="primary" variant="raised" onClick={this.onClick}>
            Lift Report を開いてゴールを設定する
          </Button>
        ) : (
          <div style={{ fontSize: '1.230769231rem' }}>管理者権限をもったユーザーにゴールの設定を依頼してください。</div>
        )}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/OnboardingScreen.tsx